import { UserAuth } from '@tools/user/auth';
import { initNavbarDesktop } from '@layout/nav-v2/desktop/initNavbarDesktop';
import { hasFeatureFlag } from '@tools/featureFlag.ts';
import { FeatureFlag } from '@enums/featureFlag.ts';
import { initNavbarMobile } from '@layout/nav-v2/mobile/initNavbarMobile';
import { navAnonymousDesktop } from './nav/anonymous/navAnonymousDesktop';
import { navAnonymousMobile } from './nav/anonymous/navAnonymousMobile';
import { navUserDesktop } from './nav/user/navUserDesktop';
import { navUserMobile } from './nav/user/navUserMobile';

const initAnonymousNavigation = () => {
  navAnonymousDesktop();
  navAnonymousMobile();
};

const initUserNavigation = () => {
  if (hasFeatureFlag(FeatureFlag.NEW_NAVBAR)) {
    initNavbarDesktop();
    initNavbarMobile();
    return;
  }

  navUserDesktop();
  navUserMobile();
};

export const nav = () => {
  if (UserAuth.isLoggedIn()) {
    initUserNavigation();
    return;
  }

  initAnonymousNavigation();
};
